import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Tasks
import TasksReducer from "./tasks/reducer";

// Dashboard
import DashboardReducer from "./dashboard/reducer";
import SalesDashboardReducer from "./salesDashboard/reducer";
// Reports
import ReportsReducer from "./reports/reducer";
import SalesReportsReducer from "./salesReports/reducer";

// Contracts
import ContractsReducer from "./contracts/reducer";
import SalesContractsReducer from "./salesContracts/reducer";

// Rebates
import RebatesReducer from "./rebates/reducer";

// Payment
import PaymentReducer from "./payment/reducer";
import SalesPaymentReducer from "./salesPayment/reducer";

// Payment
import UserInfoReducer from "./user/reducer";

// Translations
import TranslationReducer from "./translation/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Tasks: TasksReducer,
  Dashboard: DashboardReducer,
  SalesDashboard: SalesDashboardReducer,
  Reports: ReportsReducer,
  SalesReports: SalesReportsReducer,
  Contracts: ContractsReducer,
  SalesContracts: SalesContractsReducer,
  Rebate: RebatesReducer,
  Payment: PaymentReducer,
  SalesPayment: SalesPaymentReducer,
  UserInfo: UserInfoReducer,
  Translation: TranslationReducer,
});

export default rootReducer;
